import { sendAnalytics } from 'shared/utils/analytics';

export const trackPanoramaOpen = () => sendAnalytics({ action: 'Click', label: 'show_panorama' });
